import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['camera-status-info-text'])
}
const _hoisted_2 = { class: "camera-status-info-text__content" }
const _hoisted_3 = {
  key: 0,
  class: "label-xs camera-status-info-text__content_description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _renderSlot(_ctx.$slots, "default", {}, () => [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass([`${_ctx.defaultClass}`])
        }, _toDisplayString(_ctx.modelValue), 3),
        (!_ctx.isVideoArchive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ])
}